export class Credit {
  public id?: string;
  public name: string;
}
